<template>
  <BaseModal
    :title="`${_T('@Reviews about')} ${product.getName()}`"
    :modal-width="1200"
    @on-close-modal="modalStore.toggleModal(reviewModal)"
  >
    <div class="review-modal">
      <ReviewAttachmentsSlider
        class="review-modal__slider"
        :attachments="attachments"
        :without-loop="1 === reviews.length && 1 === attachments.length"
        :initial-slide="initialSlide"
        :review-id="currentReviewId"
        @on-change-review="onChangeReview"
      />
      <ProductReview
        :review="currentReview"
        :without-attachments="true"
        :max-height="windowWidth > 680 ? '500px' : 'none'"
      />
    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from "~/modules/shared/modals/BaseModal.vue";
import {
  reviewModal,
  useModalStore,
} from "~/modules/shared/modals/store/modalStore.js";
import ProductReview from "~/modules/shared/reviews/ProductReview.vue";
import ReviewAttachmentsSlider from "~/modules/shared/sliders/attachmentSlider/ReviewAttachmentsSlider.vue";
import { getReviewAttachments } from "~/utils/getters.utils.js";

onBeforeMount(() => {
  setCurrentReviewIndex();
});

const modalStore = useModalStore();
const { reviews, attachment, product } =
  storeToRefs(modalStore).getExtra.value(reviewModal);

const attachments = computed(() => {
  return reviews.flatMap((review) => getReviewAttachments(review));
});

const initialSlide = ref(0);
const currentReviewId = ref(attachments.value[0].reviewId);
const currentReview = computed(() =>
  reviews.find((review) => review.documentId === currentReviewId.value),
);

const onChangeReview = (reviewId) => {
  currentReviewId.value = reviewId;
};

function setCurrentReviewIndex() {
  const attachmentIndex = attachments.value.findIndex(
    ({ url, youtubeVideoId }) => {
      return attachment.url
        ? url === attachment.url
        : youtubeVideoId === attachment.youtubeVideoId;
    },
  );

  if (-1 !== attachmentIndex) {
    initialSlide.value = attachmentIndex;
    currentReviewId.value = attachments.value[attachmentIndex].reviewId;
  }
}

const { width: windowWidth } = useWindowSize();
</script>

<style scoped lang="scss">
.review-modal {
  @include flex-container(row, space-between, flex-start);
  gap: 32px;

  @include mobile {
    flex-direction: column;

    gap: 16px;
  }

  &__slider {
    max-width: 580px;
    height: 400px;

    @include mobile {
      max-width: none;
    }
  }
}
</style>
